/**
 * Generate provider-aware OTP delivery message.
 * Supports multiple channels: whatsapp, sms, email, push, etc.
 */

export type DeliveryChannel = 'whatsapp' | 'sms' | 'email' | 'push' | string

export function getOTPDeliveryMessage(channel: DeliveryChannel, phone: string): string {
  switch (channel.toLowerCase()) {
    case 'whatsapp':
      return `We sent a 6-digit verification code to your WhatsApp number (${phone}).`
    case 'sms':
      return `We sent a 6-digit verification code via SMS to ${phone}.`
    case 'email':
      return `We sent a 6-digit verification code to your email address.`
    case 'push':
      return `We sent a 6-digit verification code to your app notifications.`
    default:
      return `We sent a 6-digit verification code to ${phone}.`
  }
}

/**
 * Arabic translation variant.
 * Can be used with i18n systems or standalone.
 */
export function getOTPDeliveryMessageAr(channel: DeliveryChannel, phone: string): string {
  switch (channel.toLowerCase()) {
    case 'whatsapp':
      return `لقد أرسلنا رمز التحقق المكون من 6 أرقام إلى رقم WhatsApp الخاص بك (${phone}).`
    case 'sms':
      return `لقد أرسلنا رمز التحقق المكون من 6 أرقام عبر الرسائل النصية إلى ${phone}.`
    case 'email':
      return `لقد أرسلنا رمز التحقق المكون من 6 أرقام إلى عنوان بريدك الإلكتروني.`
    case 'push':
      return `لقد أرسلنا رمز التحقق المكون من 6 أرقام إلى إشعارات التطبيق الخاصة بك.`
    default:
      return `لقد أرسلنا رمز التحقق المكون من 6 أرقام إلى ${phone}.`
  }
}
